import { SplitOrderInvoicesListPageState } from './split_order_invoices_list_types';

export function splitOrderInvoicesListPageStateVM(): SplitOrderInvoicesListPageState {
    return {
        init: false,
        canEdit: false,
        loading: false,
        action: 'QUERY',
    };
}
